<template>
  <div data-testid="startup-load-error" role="alert">
    <b-card class="centered-card">
      <template #header>
        <GradientHeading>Something went wrong</GradientHeading>
      </template>

      <p class="text-center">
        We could not load your merchant. Please try again.
      </p>
      <p v-if="status" class="text-center text-muted">Error {{ status }}</p>
      <p class="text-center">
        <b-button
          variant="outline-blue"
          pill
          data-testid="startup-load-error-retry-btn"
          :disabled="isRetrying"
          @click="retry"
        >
          Try again
        </b-button>
        <b-button
          variant="link"
          data-testid="startup-load-error-sign-out-btn"
          @click="signOut"
        >
          Sign out
        </b-button>
      </p>
    </b-card>
  </div>
</template>

<script>
import GradientHeading from '@/components/Elements/GradientHeading/GradientHeading.vue'
import { loadStartup } from '@/utils/startup-load.js'

export default {
  components: { GradientHeading },
  data() {
    return {
      isRetrying: false
    }
  },
  computed: {
    status() {
      return this.$store.state.dataStore.startupLoadError?.status
    }
  },
  methods: {
    async retry() {
      this.isRetrying = true
      try {
        await loadStartup({ store: this.$store, router: this.$router })
      } finally {
        this.isRetrying = false
      }
    },
    signOut() {
      this.$store.dispatch('logout')
    }
  }
}
</script>
